import React, { useEffect, useState } from "react"
import BackgroundHelper from "../../Common/BackgroundHelper"
import Verificationlink from "../../../../assets/images/lystfacelogos/verificationlinksend.svg"
import VerificationHelper from "../../Common/VerificationHelper"
import { loginUser, LoginUserReset, registerUserReset, ResendRegisterUser, resetLoginResponseMsg, resetRegisterResponseMsg } from "../../../../store/actions"
import PropTypes from "prop-types"
import { useDispatch, useSelector } from "react-redux"
import BackgroundAuthentication from "../../Common/BackgroundAuthentication"
import SupportLayoutHelper from "../../Common/SupportLayoutHelper"
import Verfiedlogo from "../../../../assets/images/lystfacelogos/verified.svg"
import Verfied from "./Verified/Verfied"
import { LystfaceVerifyOTP, LystfaceVerifyUser } from "../../../../helpers/lystface_helper"
import Cookies from 'js-cookie'
import withRouter from "../../../Common/withRouter"
import { CustomToast } from "../../Common/CustomToast"
import { useNavigate } from "react-router-dom"
import Secure from "../../../../constants/secure/Secure"
import { isNotNullOrUndefined, maskEmail } from "../../../../common/functions"
import { resendLoginOtp, resendOtp, resetResendOtpResponseMsg, sendEmail, toggleTwoFactorAuth, updateContactDetails, verifyEmail, verifyLoginOTP, verifyOTP } from "../../../../store/menu/application/actions"
import { CHECKBOX_STATUS_UNCHECKED } from "react-bootstrap-table-next"
import TryOtherOptionsLayout from "./TryOtherOptionsLayout"
import config from "../../../../config"



const VerifylinkResendLayout = props => {
  const dispatch = useDispatch()
  const [verified, setVerified] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const SignupState = useSelector(state => state.Account)
  const loginState = useSelector(state => state.Login)
  const { user: email, plan_id: planId, userpwd: userPassword, loading, registrationError, registrationErrorMessage, emailforLogin, pswdforLogin } = SignupState
  const { loginError, loginErrorMessage, loading: loginLoading, email: loginEmail } = loginState
  const otpLength = 6
  const [otp, setOtp] = useState(Array(otpLength).fill(''));
  const isLoggedIn = Cookies.get("SESSION_ID")
  const usermail = Cookies.get("RESEND_ID")
  const navigate = useNavigate();
  const [errorStatus, setErrorStatus] = useState({ error: false, message: null })
  const userEmail = email ? email : usermail ? usermail : loginEmail ? loginEmail : null
  const [timeleft, setTimeleft] = useState(5)
  const [isChecked, setIschecked] = useState(false)
  const AccountSetting = useSelector(state => state.Application);
  const { verifyPhone: { loading: verifyLoading, error: verifyError, from: verifiedFrom, responseMessage: verifyResponseMessage } } = AccountSetting
  const { resendOtp: { loading: resendLoading, error: resendError, from: resendedFrom, responseMessage: resendResponseMessage } } = AccountSetting
  const { twoFactorAuth: { loading: twoFactorLoading, error: twoFactorError, responseMessage: twoFactorResponseMessage } } = AccountSetting
  const { verifyLoginPhone: { loading: verifyLoginLoading, error: verifyLoginError, responseMessage: verifyLoginResponseMessage } } = AccountSetting
  const { updateContact: { loading: updateContactLoading, error: updateContactError, responseMessage: updateContactResponseMessage } } = AccountSetting
  const { verifyEmail: { loading: verifyEmailLoading, error: verifyEmailError, responseMessage: verifyEmailResponseMessage } } = AccountSetting
  const { resendLoginOtp: { loading: resendLoginOtpLoading, error: resendLoginOtpError, from: resendLoginOtpedFrom, responseMessage: resendLoginOtpResponseMessage } } = AccountSetting
  const { sendEmail: { loading: sendEmailLoading, error: sendEmailError, responseMessage: senndEmailResponseMessage } } = AccountSetting
  const { basic } = config.planIds





  const [timeLeft, setTimeLeft] = useState(30);

  useEffect(() => {
    // Only start the countdown if there's time left
    if (timeLeft > 0) {
      const timerId = setInterval(() => {
        setTimeLeft(prevTime => prevTime - 1);
      }, 1000);

      // Cleanup the interval on component unmount or when timer ends
      return () => clearInterval(timerId);
    }
  }, [timeLeft]);

  useEffect(() => { //when editing email and once its verified then updateContact will be triggered which will update the contact details
    if (!verifyEmailError && verifyEmailResponseMessage && props?.from === "email") {
      dispatch(updateContactDetails({ from: "email", cmp_email: props?.email }))
      // dispatch(resetResendOtpResponseMsg())

    }
  }, [verifyEmailError])




  useEffect(() => {   // This logic will be applied when user is verifying otp then we need to trigger twoFactor api once its verified /same if phone otp is verified from account settings when editing phone number then updateContact will be triggered which will update the contact details
    if (!verifyError) {
      if (verifiedFrom === "two-factor-auth") {
        dispatch(toggleTwoFactorAuth({ factor: true }))
        // dispatch(resetResendOtpResponseMsg())
      }
      if (verifiedFrom === "phone" && !props?.onlyVerify) {
        dispatch(updateContactDetails({ from: "phone", cid: props?.cmp_phone_code, cmp_phone: props?.phone, cmp_phone_code: props.dialCode }))
        // dispatch(resetResendOtpResponseMsg())
      }

    }
    if (verifyError || verifyLoginError || verifyEmailError) {
      setErrorStatus({ error: true, message: verifyResponseMessage || verifyLoginResponseMessage || verifyEmailResponseMessage })
    }
  }, [verifyError, verifyLoginError, verifyLoginResponseMessage, verifyResponseMessage, verifyEmailError, verifyEmailResponseMessage])



  useEffect(() => {
    if (isNotNullOrUndefined(registrationErrorMessage) || isNotNullOrUndefined(loginErrorMessage) || (isNotNullOrUndefined(resendResponseMessage)) || isNotNullOrUndefined(twoFactorResponseMessage) || isNotNullOrUndefined(updateContactResponseMessage) || isNotNullOrUndefined(resendLoginOtpResponseMessage) || (isNotNullOrUndefined(verifyResponseMessage) && props.onlyVerify) || isNotNullOrUndefined(senndEmailResponseMessage)) {
      CustomToast({
        message: registrationErrorMessage ? registrationErrorMessage : loginErrorMessage ? loginErrorMessage : twoFactorResponseMessage ? twoFactorResponseMessage : updateContactResponseMessage ? updateContactResponseMessage : resendLoginOtpResponseMessage ? resendLoginOtpResponseMessage : verifyResponseMessage ? verifyResponseMessage : senndEmailResponseMessage ? senndEmailResponseMessage : resendResponseMessage,
        status: registrationError || loginError || resendError || twoFactorError || updateContactError || resendLoginOtpError || verifyError || sendEmailError ? 'failure' : 'success',
        closeToast: () => {
          console.log('Toast closed');
        },
      })
      dispatch(resetRegisterResponseMsg())
      dispatch(resetLoginResponseMsg())
      dispatch(resetResendOtpResponseMsg())
      setErrorStatus({ error: false, message: null })

      if ((isNotNullOrUndefined(twoFactorResponseMessage) && !twoFactorError) || (isNotNullOrUndefined(updateContactResponseMessage) && !updateContactError) || (isNotNullOrUndefined(verifyResponseMessage) && !verifyError && props?.onlyVerify)) {
        props.handleClose();
      }
      if ((isNotNullOrUndefined(resendResponseMessage) && !resendError) || (isNotNullOrUndefined(registrationErrorMessage) && !registrationError) || (isNotNullOrUndefined(resendLoginOtpResponseMessage) && !resendLoginOtpError) || (isNotNullOrUndefined(senndEmailResponseMessage) && !sendEmailError)) {
        setTimeLeft(30)
        setOtp(Array(otpLength).fill(''))
      }
      if (loginError && isNotNullOrUndefined(loginErrorMessage)) {
        navigate("/login")
      }



    }
  }, [registrationError, registrationErrorMessage, loginErrorMessage, loginError, resendResponseMessage, resendError, resendLoginOtpError, resendLoginOtpResponseMessage, twoFactorResponseMessage, twoFactorError, updateContactError, updateContactResponseMessage, verifyResponseMessage, verifyError, sendEmailError, senndEmailResponseMessage])


  const ResendVerificationLink = () => {   //This function will be triggering Based on from where user is resending 
    if (props.from === "verify-email" || props?.from === "other-email" || props?.from === "login-unverfied") {
      const ResendSignupVerification = {
        email: props.from === "email" ? props?.email : userEmail,
      }
      if (props?.from === "other-email") {
        ResendSignupVerification["login"] = true
      }
      dispatch(ResendRegisterUser(ResendSignupVerification))
    }
    if (props.from === "email") {
      const payload = {
        email: props?.email

      }
      dispatch(sendEmail(payload))
    }
    if (props?.from === "two-factor-auth" || props?.from === "phone") {
      ResendOtp(false, false)
    }
    if (props?.from === "verify-phone") {
      ResendOtp(true, false)
    }


  }

  const redirectToLogin = () => {
    props.router.navigate("/dashboard")
  }


  // useEffect(() => {   // Once the user is signedup and verified we need to trigger login api to redirect to dashboard
  //   if (verified && !isLoggedIn) {
  //     const LoginData = {
  //       email: emailforLogin ? emailforLogin : props?.email,
  //       pwd: pswdforLogin ? Secure.Encrypt(pswdforLogin) : props?.pswd,       //here props?.pswd is login password and we are not encrypting as we have already encripted
  //     }
  //     dispatch(loginUser(LoginData, props.router.navigate))

  //   }

  // }, [verified, isLoggedIn])

  const VerifyUser = async () => {   //This function will be triggering when user wants to  verify email while signing up
    const encrypetd = Secure.Encrypt(otp.join('').toString())
    setIsLoading(true)
    try {
      const payload = {
        cmp_email: userEmail,
        encOtp: Secure.Encrypt(otp.join('').toString()),

      }
      const Verfied = await LystfaceVerifyUser(payload)
      if (Verfied.responseCode) {
        setIsLoading(false)
        setVerified(true)
        Cookies.set("SESSION_ID", true)
        setTimeout(() => {
          redirectToLogin()
        }, 3000);




      } else {
        setErrorStatus({ error: true, message: Verfied?.responseMessage, email: Verfied?.response?.email })
        setVerified(false)
        setIsLoading(false)
      }
    } catch (error) {
      setErrorStatus({ error: true, message: Verfied?.responseMessage, email: Verfied?.response?.email })
      setIsLoading(false)
    }
  }

  const ResendOtp = (fromLogin, fromSend) => {   //This function will be triggering Based on from where user is resending email if resending while loggin in or from account settings
    const payload = {
      login: fromLogin,
      cmp_phone_code: props?.cmp_phone_code,
      cmp_phone: props?.phone,

    }

    if (props?.from === "verify-phone") {
      dispatch(resendLoginOtp(payload, fromSend))

    }
    else {
      dispatch(resendOtp(payload, fromSend))

    }
  }
  const VerifyOTP = (fromLogin) => {   //This function will be triggering Based on from where user is verifying if verifying while loggin in or from account settings
    const Payload = {
      login: fromLogin,
      cmp_email: props?.email,
      encOtp: Secure.Encrypt(otp.join('').toString()),
      remember: props.from === "verify-phone" ? isChecked : false

    }
    if (props.from === "phone" && !isChecked) {
      setErrorStatus({ ...errorStatus, checkBoxError: true })
    }
    else if (props.from === "verify-phone" || props.from === "other-email") {
      dispatch(verifyLoginOTP(Payload, props.router.navigate))

    }
    else {
      dispatch(verifyOTP(Payload, props?.from))
    }

  }

  const VerifyEmail = () => {          //This function will be triggering when user wants verify email when updatinge mail in account settings
    const payload = {
      cmp_email: props?.email,
      encOtp: Secure.Encrypt(otp.join('').toString()),

    }
    dispatch(verifyEmail(payload))

  }

  const onClickSubmit = () => {         //Based on from parameter we are triggering different apis as we have this layout common in verify email and verify phone while login and when turning two factor auth and when updating email or phone number
    if (props.from === "verify-email" || props?.from === "login-unverfied") {
      VerifyUser(navigate)
    }
    if (props?.from === "email") {
      VerifyEmail()
    }
    if (props?.from === "verify-phone" || props?.from === "other-email") {
      VerifyOTP(true)
    }
    if (props?.from === "two-factor-auth" || props.from === "phone") {
      VerifyOTP(false)
    }

  }

  const handleclickCheckBox = () => {
    setIschecked(!isChecked)
  }

  const onClickClose = () => {
    setErrorStatus({ error: false, message: null })
    props?.handleClose()
  }

  const handleBack = () => {
    if (props.handleClickTryOtherOptions) {
      props.handleClickTryOtherOptions(false)

    }
    if (props?.setSendFromStatus) {
      props.setSendFromStatus(null)

    }
    if (props.from === "login-unverfied") {
      dispatch(registerUserReset())

    }
    dispatch(resetResendOtpResponseMsg())
    if (props.from === "verify-phone" || props.from === "other-email" || props.from === "login-unverfied") {
      dispatch(LoginUserReset())

    }
    else {
      navigate(`${planId ? `/signup?plan_id=${planId}` : `/signup?plan_id=${basic}`}`)
    }
  }

  return (
    <div>
      {
        props?.tryOtherOptions ?
          <TryOtherOptionsLayout setSendingFrom={props?.setSendingFrom} sendEmailLoading={loading} sendPhoneLoading={resendLoginOtpLoading} handleBackClick={handleBack} />
          :
          (!verified) ?
            <VerificationHelper
              from={"verify-email"}
              loading={loading || resendLoading && resendedFrom !== "send" || resendLoginOtpLoading || sendEmailLoading}
              resend={ResendVerificationLink}
              imgsrc={props.logo ? props.logo : Verificationlink}
              isLogo={props.isLogo !== null && props.isLogo !== undefined ? props?.isLogo : true}
              title={props.title ? props.title : "Verify your e-mail"}
              subtitle={props?.message ? props?.message : <div>We have sent a code to {maskEmail(userEmail ? userEmail : props?.email)}. Please enter it below.</div>}
              onClickSubmit={onClickSubmit}
              isVerifyLoading={isLoading || verifyLoading || twoFactorLoading || verifyLoginLoading || verifyEmailLoading || updateContactLoading}
              otp={otp}
              setOtp={setOtp}
              otpLength={otpLength}
              resendTimeLeft={timeLeft}
              handleCheckBox={handleclickCheckBox}
              checkboxContent={props.checkboxContent}
              fromRoute={props.from}
              errorDetails={errorStatus}
              buttonText={props?.buttonText}
              handleClose={onClickClose}
              isChecked={isChecked}
              isTryOtherOptions={props?.from === "verify-phone" || props?.from === "other-email"}
              handleClickTryOtherOptions={props.handleClickTryOtherOptions}
              handleBackClick={handleBack}
              setErrorStatus={setErrorStatus}
            />
            :
            props.from !== "edit-email" &&
            <SupportLayoutHelper
              imgsrc={Verfiedlogo}
              title={"Email verified successfully!"}
              layout={<Verfied isLoggedIn={isLoggedIn} redirectToLogin={redirectToLogin} timeleft={timeleft} loading={loginLoading} />}
              from="verify-email"
            />
      }



    </div>
  )
}

export default withRouter(VerifylinkResendLayout)

VerifylinkResendLayout.propTypes = {
  email: PropTypes.string,
  history: PropTypes.object,
  loading: PropTypes.bool,
}
